module.exports = __webpack_public_path__ + "images/5d849c6ab20d9e50b9f92b448d9f6c79-switzerland.png";